"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiDropzone = void 0;
const callable_1 = require("client/components/ui/callable");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const preventDefault_1 = require("client/components/ui/preventDefault");
const React = require("react");
const react_1 = require("react");
const react_dropzone_1 = require("react-dropzone");
require("./dropzone.less");
const dropZoneActiveStyle = {
    animation: "border-dance 20s infinite linear",
    background: `linear-gradient(90deg, rgba(38, 190, 172, 0.5) 50%, transparent 50%),
      linear-gradient(0deg, rgba(38, 190, 172, 0.5) 50%, transparent 50%),
      linear-gradient(90deg, rgba(38, 190, 172, 0.5) 50%, transparent 50%),
      linear-gradient(0deg, rgba(38, 190, 172, 0.5) 50%, transparent 50%)`,
    backgroundRepeat: "repeat-x, repeat-y, repeat-x, repeat-y",
    backgroundSize: "12px 2px, 2px 12px, 12px 2px, 2px 12px",
    backgroundPosition: "left top, right top, left bottom, left top",
    border: "none",
    borderRadius: "14px",
    height: "280px"
};
class UiDropzone extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleDrop = preventDefault_1.preventDefault(() => {
            callable_1.callable(this.props.onDrop);
        });
    }
    render() {
        const { className = "", loading } = this.props;
        const loadingClass = loading ? " ui-dropzone__loading-bg--loading" : "";
        return (React.createElement(react_dropzone_1.default, { activeStyle: dropZoneActiveStyle, className: `ui-dropzone ${className}`, disabled: this.props.disabled || false, onDrop: this.props.onDrop },
            React.createElement("div", { className: "ui-dropzone__children" }, this.props.children),
            React.createElement("div", { className: `ui-dropzone__loading-bg${loadingClass}` },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "ui-dropzone__loading-indicator" }))));
    }
}
exports.UiDropzone = UiDropzone;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/dropzone/dropzone.tsx
// module id = 2710
// module chunks = 0 1